export var menuItems = {
  "data": [
    {
      "path": "/empleados/informacion",
      "title": "Información General",
      "icon": "stroke-user",
      "iconf":"fill-user",
      "type": "extTab",
      "tab": "info",
      "active": true
    },
    {
      "title": "Documentación",
      "icon": "stroke-file",
      "iconf":"fill-file",
      "type": "extTab",
      "tab": "docs",
      "active": false,
    },
    {
      "title": "Contratos",
      "icon": "stroke-editors",
      "iconf":"fill-editors",
      "type": "extTab",
      "tab": "contracts",
      "active": false
    }
  ]
}